var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _polygon, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _line, _path302, _path303, _path304, _path305, _path306, _path307, _path308;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgPantryItems = function SvgPantryItems(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M239.8,404.1a45.86,45.86,0,0,1-11.7-1.6c0-9-2.3-14.2,9.4-14.7,2.9.3,10.2-1.7,9.5,2.6-.4,4.2,2.6,11,4.2,12.6-3.3-4.2-4.4-9.6-4.1-14.8-23.5-4.9-35.8,17.6-4.4,16C241.7,404.2,240.8,404.1,239.8,404.1Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M253.1,306c.2-.2.5-.4.7-.6A3.19,3.19,0,0,0,253.1,306Z",
    fill: "none"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M251.8,307.5c.2-.2.4-.5.6-.7A4.35,4.35,0,0,0,251.8,307.5Z",
    fill: "none"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M254.6,304.6c.2-.2.5-.4.7-.6A4.35,4.35,0,0,1,254.6,304.6Z",
    fill: "none"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M281.4,393c15.5,5.9,32.2.9,48.1-2-12.2,3.7-68.2,10.9-61.2-11.7,7.8-19,6.8-46.7,25.7-58.3a25.42,25.42,0,0,0-12.7,14.7c-3.6,17.5-15.8,36.2-12.1,54C273.6,390.9,277.9,392.1,281.4,393Z",
    fill: "none"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.3,303.4c.3-.2.5-.3.8-.5A2.18,2.18,0,0,0,256.3,303.4Z",
    fill: "none"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M278.8,394.8c-2.5-.4-8.3-1.5-10.7-1.7.1-.1,3.5.5,3.7.5,2.3.8,11.1.2,8.9,4.8-.8,1.7-1.7,6.2-4.1,5.8-.3,0-12.8.6-12.8.6h0c2.1-.7,14.6.8,15.3-2.3C279.8,400.3,283.1,395.4,278.8,394.8Z",
    fill: "none"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5,417.3c-8,3-26.9-3.4-29.3-4,10,4,39.6,11.4,38.8-11C313,403.7,312.7,413.8,303.5,417.3Z",
    fill: "none"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M248.6,312.7c.1-.3.3-.6.4-.9C248.9,312.1,248.7,312.4,248.6,312.7Z",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M258,302.3a3.55,3.55,0,0,1,.9-.4A3.55,3.55,0,0,0,258,302.3Z",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M247.9,314.7a4.18,4.18,0,0,1,.4-1A3,3,0,0,0,247.9,314.7Z",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M262.7,411c7.2,1.3,5.7.6,18.4,2C268.4,411.6,269.9,412.3,262.7,411Z",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M262.7,411a11.42,11.42,0,0,1-2.6-.9C260.9,410.4,261.8,410.7,262.7,411Z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M249.5,310.9a3.51,3.51,0,0,1,.5-.8A2.18,2.18,0,0,0,249.5,310.9Z",
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5,309.1a4.35,4.35,0,0,1,.6-.7A4.35,4.35,0,0,0,250.5,309.1Z",
    fill: "none"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M257.6,408.8a11.51,11.51,0,0,0,2.5,1.2A11.51,11.51,0,0,1,257.6,408.8Z",
    fill: "none"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M307.9,365.4l-2.3,2A22,22,0,0,0,307.9,365.4Z",
    fill: "none"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M306.9,359.3c2.4-.4,3.7,2.8,2.5,4.7,2.4-6.8-5.8-5-8.1-1.1h0C303,361.7,304.5,358.9,306.9,359.3Z",
    fill: "none"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M263.9,300.1c.3-.1.7-.1,1-.2A3.55,3.55,0,0,1,263.9,300.1Z",
    fill: "none"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M305.9,378.2h0c-.2,0-.4-.1-.6-.1A1.27,1.27,0,0,1,305.9,378.2Z",
    fill: "none"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M266,299.8a3.4,3.4,0,0,0,1-.1A3.4,3.4,0,0,1,266,299.8Z",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.5,379.8a2.47,2.47,0,0,0-2.2-1.7c5.7,1.7.2,7.3-2.8,8.9a32.34,32.34,0,0,0,4.5-3.8A3.27,3.27,0,0,0,308.5,379.8Z",
    fill: "none"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M302.3,344.2a2.5,2.5,0,0,0-.8,1.8c1-3,5.7-7.6,8.8-4.8C307.6,338.3,304.1,342.2,302.3,344.2Z",
    fill: "none"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M292,342.4c-.1,2.6-3.3,4.4-5.3,5.6,3.6-1.3,8.8-8.1,2.3-8.9C290.7,339.1,292.6,340.5,292,342.4Z",
    fill: "none"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M261.9,300.7c.3-.1.7-.2,1-.3C262.5,300.5,262.2,300.6,261.9,300.7Z",
    fill: "none"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M259.9,301.4l.9-.3Z",
    fill: "none"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M286.5,348.1a.37.37,0,0,0-.3.1A.37.37,0,0,1,286.5,348.1Z",
    fill: "none"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8,169.1c-14.8-2.5-28.3-6-40.4-15.1C38,163.8,52.4,166.7,66.8,169.1Z",
    fill: "none"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M205.3,143.4c.1.1.1.3.2.4C205.5,143.7,205.4,143.6,205.3,143.4Z",
    fill: "none"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5,406.1c-1.9.7-3.8,1.4-5.6,2.2,1.8-.8,3.6-1.5,5.6-2.2Z",
    fill: "none"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,150.3a12.4,12.4,0,0,0,2.8,2.8A24.67,24.67,0,0,1,22.8,150.3Z",
    fill: "none"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M205,143c.1.1.1.2.2.3C205.2,143.2,205.1,143.1,205,143Z",
    fill: "none"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M350.2,45.1c0,5.4-7.7,10.3-20.5,14,52.6-18.5-6.3-35.3-58.3-34.8C315,24.2,350.2,33.6,350.2,45.1Z",
    fill: "none"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M376,417.8h0a49.46,49.46,0,0,1,11-7.7c-7.2,4.1-17.7,9.7-13.2,19,0-.5.1-1,.1-1.6C371.3,424.2,372.9,420.3,376,417.8Z",
    fill: "none"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M204.7,142.5c.1.1.2.2.2.3C204.9,142.7,204.8,142.6,204.7,142.5Z",
    fill: "none"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M371,53.1c-7.5,6.5-16.3,10.3-25.8,13C353.2,66.5,379,47.7,371,53.1Z",
    fill: "none"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7,126.2a247.23,247.23,0,0,0-33.6,2.2A245,245,0,0,1,113.7,126.2Z",
    fill: "none"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7,164.2c-37.1,0-67.7-7.5-71.4-17,3.5,22,144.7,22.3,143.2-2h0C185.4,155.7,153.3,164.2,113.7,164.2Z",
    fill: "none"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8,128.6c.2,0,.5-.1.7-.1C79.2,128.5,79,128.6,78.8,128.6Z",
    fill: "none"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M206.2,147.9a8.16,8.16,0,0,1-1.4,2.6,5.58,5.58,0,0,0,.8-6.6A5.15,5.15,0,0,1,206.2,147.9Z",
    fill: "none"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8,153.3a52.82,52.82,0,0,1-19,10.4,80.89,80.89,0,0,0,7.6-3.1c-30.7,12.3-65,13.7-97.4,11.7,36.6.7,82.3,3.5,111.8-22A21.27,21.27,0,0,1,201.8,153.3Z",
    fill: "none"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M204.7,142.5c-2.3-2.9-5.4-5.1-8.4-7.3A34.51,34.51,0,0,1,204.7,142.5Z",
    fill: "none"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M196.9,305.7c.1,14.4.3,28.9.4,43.3h0c4.6.9,5.1,6.3,8.8,8.2v3.5c-5,9-17.4,13.8-27.6,17.2,18.6,14.1,30.4,34.9,35.2,60.7,7.8-1.5,15.7-2.7,23.6-3.6-10.5-4.7-9.3-18.4-9.1-27.9,19.5,3.8,39.8-1.5,59,5.3-21.9-10.1-56.8,5.1-73.4-13.5,1.3-11.5,22.5-16.4,33.3-14.1v-.1c-6.2-.6-13-.9-18.8,1.1V312.7C218,310.8,206.9,308.9,196.9,305.7Zm.2,71.5c-6.9,4.5-12.7,8-18.6.7,10-2.1,17.8-8.5,26.2-13.4C204.8,370.3,201.8,374.2,197.1,377.2Z",
    fill: "none"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M233.3,269.6a17.2,17.2,0,0,1,10.6-4.9A17.23,17.23,0,0,0,233.3,269.6Z",
    fill: "none"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M383.9,265.3c-.1,0-.1,0-.2-.1C383.8,265.3,383.8,265.3,383.9,265.3Z",
    fill: "none"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M247,318.8c0-.3.1-.6.1-1C247.1,318.2,247,318.5,247,318.8Z",
    fill: "none"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M313,402.1h0c1.8-1.2,5.6-1.1,7.3-1.1C318.6,401,314.8,400.9,313,402.1Z",
    fill: "none"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M247.3,316.7c.1-.3.2-.7.3-1C247.5,316,247.4,316.4,247.3,316.7Z",
    fill: "none"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M376.9,321v69.4c-2.9,22.8-16.7,21-40.2,23.1h0c23.5-2.1,37.3-.4,40.2-23.1-4.6-18.9,14.5-92.3-21.3-90.7h0A21.32,21.32,0,0,1,376.9,321Z",
    fill: "none"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M311.3,302.5a388.18,388.18,0,0,1-43.1-2.8h0A413.91,413.91,0,0,0,311.3,302.5Z",
    fill: "none"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M384.6,246.8c0,4.3-4.4,5.3-7.9,4.9v12.8a26.48,26.48,0,0,1,6.9.6c.3-.4-.5-15.7.3-15.9,1.4-2.4.7-14.8.5-17.5C384.8,231.6,384.5,246.3,384.6,246.8Z",
    fill: "none"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M385.2,436.1l-.2.1c13.2,7.5,28.9,9.4,43.9,11.6C414.1,445.5,398.5,443,385.2,436.1Z",
    fill: "none"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M552.5,430.6a74.55,74.55,0,0,1-21.1,11h0C538.1,441.9,560.5,424.8,552.5,430.6Z",
    fill: "none"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M374,427.5h0a45.25,45.25,0,0,0,6.1,5.5A53.15,53.15,0,0,1,374,427.5Z",
    fill: "none"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M215.2,69c-12.8-2.6-24.8-6.5-35.6-14.5C190,63,202.4,66.5,215.2,69Z",
    fill: "none"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M533.8,423.1c0,10.5-32.1,18.9-71.6,18.9h0c50.8,1,103.2-17.3,48.2-32.9C524.8,412.6,533.8,417.6,533.8,423.1Z",
    fill: "none"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M553.8,417.9c2.8,2.6,5,7,1.9,10h0c5.3-6.7-5.3-13.1-10.2-16.5a69.08,69.08,0,0,0-16-6.9C538.5,407.2,547.2,411.1,553.8,417.9Z",
    fill: "none"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M114.4,222.3c18.3-.4,33.7,10.7,44.4,26.2C148.2,232.7,132.6,221.9,114.4,222.3Z",
    fill: "none"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M238.4,251.7a.75.75,0,0,1,.5.1A.75.75,0,0,0,238.4,251.7Z",
    fill: "none"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M236.6,250.9a.76.76,0,0,0,.4.2A.76.76,0,0,1,236.6,250.9Z",
    fill: "none"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M236.2,250.6c-.1-.1-.3-.2-.4-.3A1.38,1.38,0,0,1,236.2,250.6Z",
    fill: "none"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8,248.7c.1.2.2.3.2.4C234.9,249,234.9,248.9,234.8,248.7Z",
    fill: "none"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M235.3,249.6c.1.1.2.3.3.4C235.5,249.8,235.3,249.7,235.3,249.6Z",
    fill: "none"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M234.5,247.8c0,.2.1.3.1.5C234.6,248.1,234.5,248,234.5,247.8Z",
    fill: "none"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3,371.8c35.1,6.4,62.8,42.3,64.4,86.5h0c.1,1.5.1,3,.1,4.6.5-44.9-28.1-84.8-64.5-91.1Z",
    fill: "none"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M234.4,246.8a.9.9,0,0,0,.1.5.9.9,0,0,1-.1-.5Z",
    fill: "none"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M207.1,227.8a101.94,101.94,0,0,1-10.3-4.3h0A101.94,101.94,0,0,0,207.1,227.8Z",
    fill: "none"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M196.6,230.9h0c1,17.2.2,34.2.4,51.3C196.8,265.1,197.5,247.9,196.6,230.9Z",
    fill: "none"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M210.4,228.9c-.1,0-.3-.1-.4-.1C210.2,228.8,210.3,228.9,210.4,228.9Z",
    fill: "none"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M197,288.1c0,3.1-.1,6.2-.1,9.4h0C196.9,294.3,197,291.2,197,288.1Z",
    fill: "none"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M217.2,179.6c-3.5,18.7.9,36.7,13.9,54-14.7-19.5-18.4-40.1-12.1-61.3a100.85,100.85,0,0,1,6-14.9A87.5,87.5,0,0,0,217.2,179.6Z",
    fill: "none"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M170.7,458.1c2-4,6.8-6.4,10.4-8.9C177.3,451.5,172.7,454.1,170.7,458.1Z",
    fill: "none"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M169.4,175a244.71,244.71,0,0,1-54.4,5.7A250.13,250.13,0,0,0,169.4,175Z",
    fill: "none"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M307,215a25.45,25.45,0,0,1-2.3,4.7c5.8-8.9,5-20.1-1.1-28.9h0C308.5,198.4,310.1,206.4,307,215Z",
    fill: "none"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M294.2,174.3h0a1.46,1.46,0,0,1-.9-.6h0a.1.1,0,0,0,.1.1C293.6,174.1,293.9,174.1,294.2,174.3Z",
    fill: "none"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M281,178h0c3.7-2.1,7.2-1.8,10.8.5A9.49,9.49,0,0,0,281,178c0-.1-.2-.1-.2,0C280.8,177.9,280.9,178,281,178Z",
    fill: "none"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M306.5,186.1c.6,2.7-3.8,0-4.8,0a14.92,14.92,0,0,1,1.5,4.5c-.3,1-.2,2.4-.9,3.2.9-.6.4-2.5,1-3.2,0-.1,0-.2-.1-.2.2.3-.3.2-.1-.1a.1.1,0,0,1,.1.1,10.45,10.45,0,0,0-1.4-4.2c4.9,2.4,6.4.3,2.6-3.7A7.33,7.33,0,0,1,306.5,186.1Z",
    fill: "none"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M297.7,180c-1.1-1.2-1.4-3.7-2.9-5.2h-.1C296.2,176.2,296.5,178.8,297.7,180Z",
    fill: "none"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M252.4,165.1c2.3-3.5,5.3-5.4,9.7-5.2-4.1-.5-7.5,1.5-9.6,5l-.1.2Z",
    fill: "none"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M66.3,373.9h0a64,64,0,0,1,19.3-3.2A64,64,0,0,0,66.3,373.9Z",
    fill: "none"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1,228H290.6a21.69,21.69,0,0,0,11.7-5.8c-14.1,13.3-38.4,2.6-43-15-11.6-3.5-20.9-16.6-17.8-28.2-3.1,11.5,6.1,24.9,17.7,28.3a30,30,0,0,0,23.1,20.6l18.8.1c15.9-15.3,19.8-41.3,9.7-60.9C320.8,186.7,316.9,212.7,301.1,228Z",
    fill: "none"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M277.9,164.1c0,.1.1.3.2.2a12.11,12.11,0,0,1,.9,3.1c.3-1-.6-2.1-.8-3.1h-.1c.1-.2,0-.2-.2-.2.4.2.4.9.6,1.3-.1-.4-.3-.8-.4-1.2-.1.1-.2,0-.2-.1a10.18,10.18,0,0,0-3.3-2.9h0A10.18,10.18,0,0,1,277.9,164.1Z",
    fill: "none"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3,354.7c1.2,6.5,6.4,10.2,13.1,12.8C36.7,364.9,31.5,361.2,30.3,354.7Z",
    fill: "none"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M137.7,364.5a57.71,57.71,0,0,0-17.5,3.3c24.8-10.6,39.1,5.6,56.4,2.3C164,374.3,151.7,361.7,137.7,364.5Z",
    fill: "none"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M388.2,409.5a.35.35,0,0,0,.2-.1C388.3,409.5,388.3,409.5,388.2,409.5Z",
    fill: "none"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M261,155c2.9-.5,5.4,3.2,7.6,3.2,3-1.7,8.5-2.6,10.4,1.4-1.9-4.1-7.3-3-10.4-1.4-2,.1-4.1-3.2-6.7-3.2h.1c-1,0-2.9-.1-2.8,1C259.1,155.4,260,155.1,261,155Z",
    fill: "none"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5,251.4c.2.1.3.1.5.2C237.8,251.5,237.6,251.5,237.5,251.4Z",
    fill: "none"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M335.5,429.9a12.13,12.13,0,0,1-.5,1.4,41.28,41.28,0,0,0,1.9-16.9C337.5,419.5,336.4,426.3,335.5,429.9Z",
    fill: "none"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M281.7,365.2c-.1-.2-.1-.4-.2-.6C281.6,364.8,281.6,365,281.7,365.2Z",
    fill: "none"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M288.5,377.3a4.07,4.07,0,0,0-1.8-.5c6.6.8,1.1,8.2-2.7,9,2.2-.9,5.6-3.1,5.7-5.7h0A2.43,2.43,0,0,0,288.5,377.3Z",
    fill: "none"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M206.8,440.1a107.56,107.56,0,0,0-15,4.3A107.56,107.56,0,0,1,206.8,440.1Z",
    fill: "none"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M303.5,387c-.2.1-.3.1-.5.2C303.2,387.1,303.3,387,303.5,387Z",
    fill: "none"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M302.9,387.1a.76.76,0,0,0-.4.1A.6.6,0,0,0,302.9,387.1Z",
    fill: "none"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M327.5,381.4c0-.2-.2-.4-.3-.6C327.2,381,327.5,381.1,327.5,381.4Z",
    fill: "none"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M286.1,366.7a3.16,3.16,0,0,1-4.3-1.3c2.4,4.3,8.9-1.1,9.2-4.5C290.8,363.6,287.9,365.1,286.1,366.7Z",
    fill: "none"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4,434.5c-.3.5-.6,1-.9,1.6C332.8,435.5,333.1,435,333.4,434.5Z",
    fill: "none"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M287.1,412.5c4.8,1.3,9.4,2.3,12.8,1.7C296.5,414.8,291.8,413.8,287.1,412.5Z",
    fill: "none"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M330.1,342.8v1.4A6.48,6.48,0,0,1,330.1,342.8Z",
    fill: "none"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M171.9,462.6a1.27,1.27,0,0,0-.1.6h0C171.9,463.1,171.9,462.8,171.9,462.6Z",
    fill: "none"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M308.2,327.5c3.9-.7,11.2,2.7,13.4-.7-2.2,4.4-13.7-2.3-16,1.9C305.6,327.5,306.2,327.4,308.2,327.5Z",
    fill: "none"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M345.1,326.6a2,2,0,0,1,.8.1c-3.6-.4-7.2-.3-10.7-.7C338.4,326.3,341.8,326.4,345.1,326.6Z",
    fill: "none"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M327.5,381.4a2.77,2.77,0,0,1,.1.9A2.77,2.77,0,0,0,327.5,381.4Z",
    fill: "none"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M301.4,413.8c1.9-.8,3.7-3.1,4.5-5.4C305,410.8,303.3,413.1,301.4,413.8Z",
    fill: "none"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M318.9,383.1l.1-.1Z",
    fill: "none"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M326.1,379.5a2.19,2.19,0,0,1,.5.3A2.19,2.19,0,0,0,326.1,379.5Z",
    fill: "none"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M321.6,326.1c1-3.7-1-11.6,2.3-13.3-3.2.6-1.2,7.3-2.2,10h0C321.7,323.9,321.5,325,321.6,326.1Z",
    fill: "none"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M182,448.8a2.51,2.51,0,0,0-.7.4A1.61,1.61,0,0,1,182,448.8Z",
    fill: "none"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M323.8,360.9c1.7-1.5,5.4-.1,4.9,2.4-.5-6.1-7.5-1.4-9.2,1.7C320.5,363.3,322.2,362.2,323.8,360.9Z",
    fill: "none"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M328.5,364.7a2.54,2.54,0,0,0,.2-1.2h0A5,5,0,0,1,328.5,364.7Z",
    fill: "none"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M461.2,335.4a2.77,2.77,0,0,1,.9.1,36.39,36.39,0,0,0-5.2,3.5h0a37.36,37.36,0,0,1,5.3-3.5A3.4,3.4,0,0,0,461.2,335.4Z",
    fill: "none"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M485.8,310a4.1,4.1,0,0,0,2.7,1.5A4.61,4.61,0,0,1,485.8,310Z",
    fill: "none"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M490.5,310.4a2.89,2.89,0,0,1-1.6.9c9.2-6.7,13.9-18.9,13.8-30.4C503,292.3,498.3,302.4,490.5,310.4Z",
    fill: "none"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M495.7,273.5a42.47,42.47,0,0,1,.8,6.1c0-3-.9-5.8-1.2-8.8h0A25.12,25.12,0,0,0,495.7,273.5Z",
    fill: "none"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M521.6,336.2c5.2-3.1,12.7-2.9,16.9-8.5C534.4,333.3,526.7,333,521.6,336.2Z",
    fill: "none"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M475.4,319.8v.3C475.4,320,475.5,319.9,475.4,319.8Z",
    fill: "none"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M539.5,326.7a.76.76,0,0,1,.4-.2C539.8,326.6,539.7,326.6,539.5,326.7Z",
    fill: "none"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M475.4,320.4h0a.37.37,0,0,1-.1.3A.37.37,0,0,0,475.4,320.4Z",
    fill: "none"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M469.5,332.3c-.4.1-.8.3-1.2.4C468.6,332.6,469,332.5,469.5,332.3Z",
    fill: "none"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M480.1,301.3c-3.2-2.9,1.8-6.1,2.9-8.9,3.6-3.6.3-18.6,8.1-13.4-7.7-6.3-4.8,14.8-11.4,18.3a2.79,2.79,0,0,0,.3,3.8C479.9,301.2,480,301.3,480.1,301.3Z",
    fill: "none"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M475.3,319.3c0,.1.1.2.1.4C475.4,319.5,475.4,319.4,475.3,319.3Z",
    fill: "none"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M484.8,300.3a2.93,2.93,0,0,1-1.6,1.3,3.32,3.32,0,0,0,1.4-1c-1,1.2-3,2-4.4.9h0c8.1,1.8,12.9-16.3,10.8-22.5C493,286.2,489.3,294.5,484.8,300.3Z",
    fill: "none"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M453.3,307.1a24.2,24.2,0,0,0,.2-3.8c-.6,18.2-22.5,29.6-20.7,48.4C431.4,334.3,449.3,323.1,453.3,307.1Z",
    fill: "none"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M511.6,494.9c-4.1-11.2-17.3-11.6-25.7-16.5-4.7-9.6-19.2-13.4-28.9-8.4,9.9-4.7,24.1-1.1,28.9,8.5,8.5,5,23.4,5.7,26,17.9A4.94,4.94,0,0,0,511.6,494.9Z",
    fill: "none"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M464.5,490a7.1,7.1,0,0,1,1.4-1c1.2-1.2,3.8-1.1,4.2.9-3.5-5.8-11,5.1-10.6,9.4h0A12.64,12.64,0,0,1,464.5,490Z",
    fill: "none"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M509.6,504.9h0c1.4.9,1.7,1.8,1.3,2.9,1.5-2.5-6.5-5.5-4.9-6.7C505.5,502.1,506.7,503,509.6,504.9Z",
    fill: "none"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M454.4,384a2.51,2.51,0,0,0-.7-.4A2.51,2.51,0,0,0,454.4,384Z",
    fill: "none"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M466.6,506.3a4.67,4.67,0,0,1,1.3,2.5c-.9-3-4.6-6.6-4.1-9.3C463.8,501.5,464.7,503.7,466.6,506.3Z",
    fill: "none"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M470.6,523.4a12.41,12.41,0,0,1-1,3.5A7.42,7.42,0,0,0,470.6,523.4Z",
    fill: "none"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M562.7,322.1c1.9,15.5-12.1,28-25.1,33,50.6-20.3,15.9-77.9-26.5-44.7C526.5,295.8,560.2,296.5,562.7,322.1Z",
    fill: "none"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M469.6,319.7c0-.1.1-.3.1-.4C469.7,319.4,469.6,319.5,469.6,319.7Z",
    fill: "none"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M522.2,345.8c-.2,0-.4.1-.6.1a1.27,1.27,0,0,1,.6-.1c23.3,1.9,32-29.3,35.8-17.5-.4-4.3-5.5-3.3-6.5.2C545.5,339,534.2,345.3,522.2,345.8Z",
    fill: "none"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M499.5,260.9c15.4,13.8,9.7,39.2-3.5,52.6a27,27,0,0,0-7.6,15,25,25,0,0,0,2.6-.7,19.73,19.73,0,0,1-2.6.7c4.2-17.2,23-27.4,20.1-47.3,1.1-19.6-22.3-33.8-38.5-22A24.08,24.08,0,0,1,499.5,260.9Z",
    fill: "none"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M460,269.8c-5.1,7.7-7.3,16.6-6.9,26.4A44.19,44.19,0,0,1,460,269.8Z",
    fill: "none"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M505,367c-.3.4-.7.7-1,1.1a28.77,28.77,0,0,1,11.1-8.5A27.59,27.59,0,0,0,505,367Z",
    fill: "none"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M453.7,375.1c0,.1-.1.2-.1.3h0c-.1.1-.1.2-.1.4C453.5,375.5,453.7,375.4,453.7,375.1Z",
    fill: "none"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M458.9,377.8c-.1.1-.2.3-.3.4C458.8,378,458.9,377.9,458.9,377.8Z",
    fill: "none"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M459.1,377.5h0c.2-.5.3-.8.5-1.2A4.33,4.33,0,0,1,459.1,377.5Z",
    fill: "none"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M444.5,336.3c7.4-10.2,17.1-19.9,15.9-33.6,1.2,13.8-8.5,23.3-15.9,33.6a3.69,3.69,0,0,0-.6,3A4.12,4.12,0,0,1,444.5,336.3Z",
    fill: "none"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M443.8,346.4c6,4.5-5.5,17.3-.5,25-2.6-7.4.6-14.5,2.6-21.5.9-3.6-4.5-5.3-5.9-1.6A3.06,3.06,0,0,1,443.8,346.4Z",
    fill: "none"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M454.7,372.1l-.1.1Z",
    fill: "none"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M517.7,320c1.7-3.1,6.8-3.4,7.6-6.7-.9,3.3-5.9,3.6-7.6,6.7a2.59,2.59,0,0,1-3.6.6c-1.4-.6-1.7-3.1-1.3-3.6C511.6,319.8,515.8,322.8,517.7,320Z",
    fill: "none"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M469.8,319.1c.1-.2.2-.3.3-.5A.91.91,0,0,0,469.8,319.1Z",
    fill: "none"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M492.9,341.1c-5.4.5-22.1,7.5-23.7.9h0c3.6,9,42.8-5.6,43.3-16.1C509.5,334,500.6,338.3,492.9,341.1Z",
    fill: "none"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M505.4,344.8c-3.4-3.6-6.9,2.4-10.7,2.4-1.9.4-4.5.8-4.4,3.3.7-4.4,8-2.9,10.7-6.1a3.06,3.06,0,0,1,4.4.4,2.6,2.6,0,0,1,.4,2.9A2.85,2.85,0,0,0,505.4,344.8Z",
    fill: "none"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M469.3,341.9a2.46,2.46,0,0,1,.5-1.5A2.46,2.46,0,0,0,469.3,341.9Z",
    fill: "none"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M455.6,379a2.81,2.81,0,0,0,3.1-.8c-1.6,2.2-5.6.4-5.1-2.2a2.49,2.49,0,0,0,1.8,2.9A.35.35,0,0,0,455.6,379Z",
    fill: "none"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M485.6,351.3h0v0Z",
    fill: "none"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M463.1,297.8a2.66,2.66,0,0,1,3,2.3c-.9-4-6.6-2.3-5.8,1.5C460.1,299.6,461,298.1,463.1,297.8Z",
    fill: "none"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M466.9,326.6a16.32,16.32,0,0,0,2.6-6.6c-.3,3.9-3.2,6.7-4.5,10.1C465.2,328.8,466.3,327.8,466.9,326.6Z",
    fill: "none"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M447.4,363.6v-.2C447.3,363.5,447.3,363.6,447.4,363.6Z",
    fill: "none"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M473.1,317.5a2.73,2.73,0,0,1,2.2,1.8c-.6-2.2-4.1-2.6-5.3-.6A2.91,2.91,0,0,1,473.1,317.5Z",
    fill: "none"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M483,354.9c-12.1-2-20.4,20.5-23.3,9.6-.1,1.4.8,2.6,2.9,3.2,6.2-4.4,10.7-13.5,20.4-12.8,1.6-.1,2.7-.9,2.7-2.5C485.7,353.9,484.5,354.7,483,354.9Z",
    fill: "none"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M464.9,291.3a.76.76,0,0,1-.1.4A.76.76,0,0,0,464.9,291.3Z",
    fill: "none"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M464.9,290.5h0a21.16,21.16,0,0,1,1.6-8.3C465.6,284.9,464.6,287.6,464.9,290.5Z",
    fill: "none"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M462.7,293.5a2.73,2.73,0,0,0,2.2-1.8c-1.8,3.7-6.8,1.3-6-2.6C458.7,291.7,460.1,294,462.7,293.5Z",
    fill: "none"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M463.2,350.1a3.08,3.08,0,0,0,1.8-2.6c-3.6,5.1-10.3,8-11.7,15.2-1.2,4.1-4.8,4.6-5.9,1.2C452.9,372.9,455.8,350.8,463.2,350.1Z",
    fill: "none"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M544.2,329.3c-1,3.5-5,5.6-7.8,7.5,4.1-1.4,12.9-10.8,3.6-10.4A3,3,0,0,1,544.2,329.3Z",
    fill: "none"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M527.7,225.9c-11.5,2.3-25.6,2.1-38,2.3-45.7-.2-73-6.1-88.5-11.4,16.1,8,88.6,15.2,126.6,9.4A.19.19,0,0,0,527.7,225.9Z",
    fill: "none"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M383.8,222.9l-.1-14.8h0Z",
    fill: "none"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1,552.3h0c27.7,0,50.2-11.2,50.2-25h0c1.3,32.3-101.6,32.2-100.4,0h0C223.9,541.1,246.4,552.3,274.1,552.3Z",
    fill: "none"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M531.9,225.7h0s3.2-.4,3-.4S531.9,225.7,531.9,225.7Z",
    fill: "none"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M545.8,223.3a35.08,35.08,0,0,1-5.8,1h0l.2.1c2-.4,4-.7,5.6-1.1C545.7,223.2,545.8,223.2,545.8,223.3Z",
    fill: "none"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M557.2,220.5c-.3.1-.5.1-.8.2C556.7,220.6,557,220.6,557.2,220.5Z",
    fill: "none"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M351.6,465.9c-28.9,13.3-66.3,13.1-102.4,12.2,31.1.7,89.8,2.4,108-17.8C356.6,462.3,354.6,464.2,351.6,465.9Zm-97,12.6,5.1.2Zm5.3.2c1.7,0,3.4.1,5.1.1C263.3,478.8,261.5,478.7,259.9,478.7Zm5.5.1h0Z",
    fill: "none"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M555.1,220.8c-.5.1-.9.2-1.1.6h0C554.2,221,554.6,220.9,555.1,220.8Z",
    fill: "none"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M435.1,131.3c1.1,7.2,0,32.2.4,39.9.1,3.9-9.2-.4-11.8-.3,2.4.2,11.2,3.7,11.9.9-.5-1.9.9-38.9-.5-40.5,2.1.3,4.1.5,6.2.7v-.1C439.1,131.7,437.1,131.5,435.1,131.3Z",
    fill: "none"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2,477h0a27.66,27.66,0,0,1-.3-4.2A29.66,29.66,0,0,0,58.2,477Z",
    fill: "none"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M453.6,173.3h0c0,3.7-9.6.4-11.4.8-.1.2,9.4,1,9.7,1.1,3.7,2.1.9-41.6,1.7-42.3h0v40.4Z",
    fill: "none"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9,471.9a24.4,24.4,0,0,1-.1,8.1c2.9-12.8-7.9-28.6-20.2-25.8C81,452.4,90.2,460.6,91.9,471.9Z",
    fill: "none"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7,543.2c-16.5.6-31.8-6.6-43.7-18.8,12,12.3,27.3,19.5,43.7,18.8a53.65,53.65,0,0,0,21.3-5.4A50.49,50.49,0,0,1,89.7,543.2Z",
    fill: "none"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1,454.5c.1,0,.1-.1.2-.1C70.2,454.5,70.2,454.5,70.1,454.5Z",
    fill: "none"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M416.8,128.6c.6,6.8,0,22.6.2,29.3.7,12.9.4,12.8-11.6,8.2,12.1,4.7,12.3,5.2,11.6-8.1V130.1a2.62,2.62,0,0,0-.2-1.5,40.66,40.66,0,0,0,6.7,1.1C421.2,129.4,418.9,129,416.8,128.6Z",
    fill: "none"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M137.7,546.9a62.15,62.15,0,0,0,30.7-9.4A62.15,62.15,0,0,1,137.7,546.9Z",
    fill: "none"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M180.1,530.2c0,1.9-.1,3.7-.1,5.6C180,533.9,180.1,532.1,180.1,530.2Z",
    fill: "none"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8,479.6c-3.4-4.8-13.2,5.5-14.8,8.4,1.8-3,12-13.9,15.2-7.6.3,1,9.9,16.8,9,17.6C60.4,496.1,51.7,481.3,50.8,479.6Z",
    fill: "none"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M472,134.3c-1.1,1.2,2.4,43.6-1.7,42.6h0c3.7.1,1-41,1.6-43.2h0A1.27,1.27,0,0,1,472,134.3Z",
    fill: "none"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M112.2,537.3a.35.35,0,0,0-.2.1C112.1,537.4,112.1,537.3,112.2,537.3Z",
    fill: "none"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M561.7,166.7c-2.8.1-9.2,4.2-10.6,1.5V130.3a2.54,2.54,0,0,1,.3-1.5c-2.1.4-4.3.8-6.7,1.1h0c2.3-.4,4.5-.7,6.6-1.1-.6,11.1-.4,28.9-.1,40.1C553.3,170.1,565.9,164.9,561.7,166.7Z",
    fill: "none"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3,479.3a95.31,95.31,0,0,0,4.4,15.6A120.43,120.43,0,0,1,23.3,479.3Z",
    fill: "none"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6,452.6l-22.7,23c11.8-10.4,31.4-41.3,49.2-23.1C79.5,445.8,68.2,444.7,60.6,452.6Z",
    fill: "none"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M416.3,479.9c14.1.9,20.1,17.7,23.5,13.4,4.1-5.4,10.6-8.1,17.4-10.5-10.1,1.3-19.4,15.2-21.4,10-3.3-6.7-19.4-17.7-26.2-11.2C410.4,479.5,412.4,479,416.3,479.9Z",
    fill: "none"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M490.4,134.6v40.3c.2,3.6-8.6,1.5-10.4,2h0c1.8-.6,10.6,1.6,10.4-2-.1-.8.2-40.3-.1-41h0C490.3,134.1,490.4,134.3,490.4,134.6Z",
    fill: "none"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M416.3,502.7a3.07,3.07,0,0,0,1.3-1.2c-4.1,3.1-7.9,6.8-9,11.3A19.21,19.21,0,0,1,416.3,502.7Z",
    fill: "none"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M468.5,521.1a4.87,4.87,0,0,0-1.2-.1A4.87,4.87,0,0,1,468.5,521.1Z",
    fill: "none"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M390.1,116.5a3.61,3.61,0,0,0,.6,2c-2.4-5.6,4.1-8.1,14.3-11.4C395.5,109.7,390.1,113,390.1,116.5Z",
    fill: "none"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8,378.5a47.85,47.85,0,0,1,7.6.3c-43.1-5.1-75.4,43.6-69.3,92.6C16.1,425.3,45.1,379.1,83.8,378.5Z",
    fill: "none"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M509.2,133.3v41h0c.1,3-10.5,2.1-12.2,2.5,1.7-.1,12.4.5,12.3-2.5-.1-.2.2-40.9-.1-41l5.6-.3Z",
    fill: "none"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7,243.4c15-11.8,34.6-10.1,48.1,4C126.3,233.3,106.8,231.6,91.7,243.4Z",
    fill: "none"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2,379.4a95.78,95.78,0,0,1-21.3-7.9,99,99,0,0,0,21.3,7.9Z",
    fill: "none"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M249.2,478.2h0c0-.1-3-24.4-1.2-38.1C246.2,453.8,249.2,478.2,249.2,478.2Z",
    fill: "none"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M527.2,172.5h0a1.83,1.83,0,0,1-1.3,1.7,1.83,1.83,0,0,0,1.3-1.7l.1-40.5h-.1Z",
    fill: "none"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M183.6,458.5c0,9.1,25.5,16.8,60.7,19.4C209.1,475.3,183.6,467.5,183.6,458.5Z",
    fill: "none"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M386.8,535.6a46.61,46.61,0,0,1-6.9-4.7A21.68,21.68,0,0,0,386.8,535.6Z",
    fill: "none"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M178.4,53.5c40.6,28.9,158.4,30.8,196-3.6h0V50c2.8-34.7-96-35.7-121.4-33.9-17.6,1.6-85.2,9.6-78.5,34.1v-.3l.1.1v-.2A33.42,33.42,0,0,0,178.4,53.5Zm93.1-29.3c120.6,2.8,84.1,44.2,0,41.6C169.5,66.4,169.5,23.6,271.5,24.2Z",
    fill: "#c3c3c3"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M197.2,288.2l-.2-.1h0c-3.8,16.4,20,13.3,31.1,16.9v-8.6C217.6,294.6,207,292.3,197.2,288.2Z",
    fill: "#c3c3c3"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M342.8,75.1a96.4,96.4,0,0,0,22.8-9.2c5.2-4,9.5-8.6,8.7-15.9h0v-.1C340.7,83.8,208.2,84,174.6,49.8,182,93.9,308.9,84.6,342.8,75.1Z",
    fill: "#99d47e"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M365.7,212.1c-6.6,8.7-15.3,12.9-24.7,15.9h24.8Z",
    fill: "#93b847"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M239.4,251.8a4.93,4.93,0,0,1-4.9-5h0c-.1-3.5,1.1-11.4-3.3-13.1h0a137.34,137.34,0,0,1-18-3.9,105.54,105.54,0,0,1-16.2-6.1c-.1,2.4-.2,4.9-.3,7.3h0c1,17.1.2,34.2.4,51.3h0v5.9h0c10,4.1,20.5,6.3,31.1,8.2-.9-12.4-.4-30.6,15.8-31.8V251.7l-4.6.1Z",
    fill: "#93b847"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M182.9,163.7c6.8-2.3,13.2-5.3,18.7-10.2a58.8,58.8,0,0,1-18.7,10.2Z",
    fill: "#f0592b"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M207.1,227.8c2,.7,3.9,1.3,5.9,1.9,41.4,14.3-19-20.1,11.9-72.2a168.7,168.7,0,0,1-20-5.5c0,5.8-3.6,9.7-8.1,13.1h0c.3,19.5.6,39,.1,58.5A91,91,0,0,0,207.1,227.8Z",
    fill: "#f0592b"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8,297.4h0v.8h0c0,2.5.1,5,.1,7.5h0c10.1,3.4,20.7,5.4,31.1,7.2V305c-10.4-1.8-21.2-3.7-31.2-7.6Z",
    fill: "#16a99e"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M330.3,209.1a66.21,66.21,0,0,1-8.7,18.9c16,1.4,33.8-1.4,44.1-15.9,0-24.6,1-49.4-.3-73.9-11.2,12.3-26.4,15.8-41.5,19.4C332.1,173.7,335.3,190.8,330.3,209.1Z",
    fill: "#f0592b"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M225,157.5h0a87.56,87.56,0,0,0-6,14.9c-6.3,21.1-2.6,41.6,12,61.3,1.1,1,2.2,2,3.3,3.1-1.6-9.9,6.2-8.9,13.2-8.7C205.7,191,257.8,110.6,303.6,157c18,19.5,16.1,52.7-2.7,71h20.5C365.7,161.9,271.8,86,225,157.5Z",
    fill: "#16a99e"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M282.3,228.1a29.83,29.83,0,0,1-23.1-20.6c-19-5.3-25.8-32.9-6.7-42.3,0-.1.1-.1.2-.1h0c2.1-3.7,5.3-5.2,9.5-5.1-.9-1.7-5.5-4.6-1-4.9-.1,0-.3-.1-.4-.1h1.1c2.6,0,4.7,3.2,6.7,3.2,4.3-3.8,16.7,1.4,6,3a15.49,15.49,0,0,1,3.6,3.1s.1.1.1-.1a25.4,25.4,0,0,1,13.1,11.6c-.8-1.9.1-3.3,1.9-2.1h0a.1.1,0,0,0-.1-.1h0a.1.1,0,0,0-.1-.1l1,.6H294l.1.1H294a.66.66,0,0,1,.5.4c3,4.3,1.9,6.1,8,6.4,4.4,2.5,6.3,8.5-.8,5a12.25,12.25,0,0,1,1.4,4.2c.1.1.2.1.1.2.1,0,.1.1.2.1a.1.1,0,0,0,.1.1c6.2,8.9,7.3,21.7,0,29.9a21.48,21.48,0,0,1-13.2,7.4c30.8,2.2,31.6-54.5,13.2-71-46.3-46.6-97.6,34.7-56.1,71.1h34.9v.1Z",
    fill: "#fff"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M278.2,164.2c.1.4.3.8.4,1.2A5.64,5.64,0,0,1,278.2,164.2Z",
    fill: "#fff"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M271.5,65.9c29.1-2,67.3-.1,78.8-20.8C325.6-5.9,61.9,49.1,271.5,65.9Z",
    fill: "#ebebeb"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M252.6,165c-3.3,6.2,9.7-3.2,8.7,1-.6,1.9-.7,8.5,2.5,5.7a21.65,21.65,0,0,0,4.3-6.5c2.7-1,7.1,1,9.9,2.3,2.2,1.1.3-2.2.2-3.1a13.68,13.68,0,0,0-3.6-3.1h0c10.8-1.5-1.8-6.8-6-3-1.9.1-4-3-6.5-3.2-5.4-.3-1.4,2.9.2,4.9C257.8,159.8,254.6,161.4,252.6,165Z",
    fill: "#93b847"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M261.7,154.9h0l.2-.1h-1C261.1,154.8,261.5,155.1,261.7,154.9Z",
    fill: "#fefdfc"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M278.2,164.2a1,1,0,0,0-.3-.1h0C277.9,164.2,278,164.3,278.2,164.2Z",
    fill: "#fe2c2f"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M252.4,165h0l.1-.1a.1.1,0,0,0-.1.1Z",
    fill: "#fe2c2f"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M245.8,197.8a28.53,28.53,0,0,0,13.4,9.5c4.8,18.3,31.2,29,44.5,13.4,7.1-8.4,6.2-21.3-.2-30-1-.2-.2,3.1-1.5,3.2-2.2-2.4-4.5-6.5-7.6-7.7-18.8,10.2-2.8-4.4-7.3-4.1-1.9-1.2-10.1-.7-6.2-4h0a9.83,9.83,0,0,1,11,.4c-.9-6.6-7.3-11.4-13.5-14.2,4.2,8.1-7.5-1.9-10.2.9a21.65,21.65,0,0,1-4.3,6.5c-3.3,2.9-3-3.8-2.5-5.7.4-4.1-11,5-8.9-.9V165C240.1,171.1,237.2,186.9,245.8,197.8Z",
    fill: "#f0592b"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M291.4,176.1a6.08,6.08,0,0,1,.3,2.3v.1c-3.6-2.3-7.2-2.6-10.8-.5h0l-.2.1h0c-4,3.4,4.8,2.8,6.8,4.2,1.4.3.7.7,0,1.5-6.9,8.4,2.1,5.8,6.7,2.4,3.5,0,8.3,13.2,8.8,4.4-.4-1.4-.6-3.2-1.5-4.5,7.2,3.4,5.2-2.4.9-4.9-5.8-.3-5.2-2-8-6.4-.3-.5-.9-.5-1.3-.9-1.9-1.2-2.7.1-1.9,2.1C291.4,175.9,291.4,176,291.4,176.1Z",
    fill: "#93b847"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M294.1,174.2h.1l-1-.6a.1.1,0,0,0,.1.1A2.18,2.18,0,0,0,294.1,174.2Z",
    fill: "#fefdfc"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M303.3,190.6v-.2h0l-.1-.1C303.1,190.4,303.1,190.6,303.3,190.6Z",
    fill: "#fe2c2f"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M280.8,178.1c.2,0,.2-.2,0-.1v.1Z",
    fill: "#fe2c2f"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8,150.4v-.1c34.2,31.3,147.5,31.3,182.1,0v.1h0v.1c2.3-2.2,1.7-5.7,0-7.9-5.6-6.6-13.4-10.5-21.5-13.7h0c-40.4-12.3-81.8-12.6-122.3-4.2C50,127.7,17.1,135.6,22.8,150.4Zm56-21.8a235.69,235.69,0,0,1,35-2.4h0c35.2-.6,73,8.6,71.7,19h0C182.1,181.9-46.4,157.2,78.8,128.6Z",
    fill: "#c3c3c3"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M169.4,175c9.5-2.1,18.9-5.1,27.3-10h0c4.4-3.4,8.1-7.2,8.1-13.1,6.5,2.4,13.3,3.9,20,5.5h0c21.9-37.6,77.1-37.5,99,.1,62.1-9.7,37.8-43.8,41.7-91.6-55.9,23.9-126.5,24.4-182.2,0-.3,21-.7,41.9-.1,62.8h0c8.2,3.2,15.8,7.1,21.5,13.8,1.8,2.2,2.3,5.7.1,7.9v-.2c-32.9,31.1-149.1,31.3-182.1.2v-.1C27.6,188.8,140.3,182.2,169.4,175Z",
    fill: "#93b847"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9,233.5c22.4-18.5,56.1-13.8,73.5,10.3,7.5,10.8,33.2-5.2,41.1-12.9h0c.1-2.4.2-4.8.3-7.3h0c.6-19.5.3-39-.1-58.5-48.3,21.7-117.8,22.1-166,0-.4,22-.7,43.9.2,65.8,9.6,10.8,24,14.6,37.7,17.6A65.7,65.7,0,0,1,81.9,233.5Z",
    fill: "#fdb73e"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3,354.7c3.8,14.4,23.8,15.8,36.2,19.2a63.11,63.11,0,0,1,31.1-2.2h-.1c13.3.3,27.4-6.6,40.4-7.3a62.41,62.41,0,0,1,31.9,7.6c11.9-3.6,29.8-6.6,27.7-23h0c-.1-14.5-.3-28.9-.4-43.3h0c0-2.5,0-5-.1-7.5-10.8,13.8-27.8,16.4-43.7,19.6-13.2,13.9-33.9,22.4-51.6,17.2-10.9-2.6-19.5-9.5-27.4-17.2-15.6-2.9-33.4-6.3-43.7-19.5L30.1,349h0A17.74,17.74,0,0,0,30.3,354.7Z",
    fill: "#ef6ba0"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5,309.7a110.22,110.22,0,0,0,28.8,8.1c20.6,24.4,57.3,24.2,79,0,15.9-3.2,32.9-5.8,43.7-19.6v-.7h0c0-5,.1-10.2.1-15.3h0c-.2-17.1.6-34.2-.4-51.3v-.1c-10.1,11.2-24,14.4-37.7,17.6-20.4-34.6-70.4-34.3-90.1,0-13.7-3.1-28.2-6.6-37.8-17.6-.9,22.5-.4,44.9-.3,67.4A32.21,32.21,0,0,0,45.5,309.7Zm95-61.7c23,23.4,9.2,74-25.3,74.6-41.5.5-51.6-56.8-23.4-79.3C107,231.3,127.3,233.3,140.5,248Z",
    fill: "#d6842d"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1,379.4c-12-2.1-21.6-8.7-31.4-14.9,0,12.1,14.2,16.8,23.7,20.1A65,65,0,0,1,54.1,379.4Z",
    fill: "#015e85"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M178.5,377.9c7.8,10.6,26.1-2.1,26.3-13.4C196.3,369.5,188.6,375.8,178.5,377.9Z",
    fill: "#015e85"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7,243.4c-36.3,27.1-5.6,100.6,40.9,73.9C176,290.7,138.1,209.6,91.7,243.4Z",
    fill: "#fdb73e"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M113.7,164.2c39.6,0,71.7-8.5,71.8-19h0c1.3-10.3-36.6-19.5-71.7-19C34.3,124.2,6.3,162,113.7,164.2Z",
    fill: "#ebebeb"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M383.8,223c0-.1-.1-14.8-.1-14.9h0l.1,14.9Z",
    fill: "#bd4b28"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M527.7,225.9c-11.4.7-23.4,2.4-35,2.2C504.1,227.9,517.4,227.8,527.7,225.9Z",
    fill: "#bd4b28"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,246.5c.4-.3.1-9.6.2-10.1h-.1Z",
    fill: "#bd4b28"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M545.8,223.3c0-.1-.1-.1,0,0-1.5-.7-4.2.4-5.8,1C541.9,224.3,544,223.5,545.8,223.3Z",
    fill: "#bd4b28"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M555.6,220.7c-.6.1-1.3.2-1.6.7,1.9-.5,3.8-1.1,5.7-1.6A18.74,18.74,0,0,1,555.6,220.7Z",
    fill: "#bd4b28"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M383.6,249.8v15.5h0c.1,0,.1,0,.2.1l-.1-16h0C383.8,249.5,383.7,249.6,383.6,249.8Z",
    fill: "#bd4b28"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M383.8,225.8h0c0,.1-.3,4.5,0,4.5Z",
    fill: "#bd4b28"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M532.6,225.2a.56.56,0,0,0-.6.5l3-.4C534.1,224.5,533.3,225,532.6,225.2Z",
    fill: "#bd4b28"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,383.9h0c.2-8.4.2-128.8,0-136.7V383.9Z",
    fill: "#bd4b28"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,207.8v15Q584.9,215.3,584.6,207.8Z",
    fill: "#bd4b28"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5,406.1c7.3-2,5.5-2.3-.1-5l.1,5Z",
    fill: "#d6842d"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M545.5,411.4c4.8,3.3,15.6,9.8,10.3,16.5h0v1c14.3-6.9,26.3-22,28.2-38.6C581.3,393.4,571.1,404.3,545.5,411.4Z",
    fill: "#d6842d"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M404.9,126.7c.9,4.9-2.1,39.8,1.7,40.1,12,4.1,10.8,2.9,10.5-8.8-.2-6.6.3-22.7-.2-29.4,2.1.5,4.7.7,6.8,1.3h.1c-1.4,9.2-.1,23.5-.5,33,.5,1.6-1.4,8.5,1.7,8.3,2.8-.4,10.2,4,10.7,0-.4-7.9.7-32.6-.4-39.9l6.2.6v.1h.1c.8,2.2-1.6,40.6,1,42.1,1.8-.3,11.3,2.8,11.4-.7h0V133h0l6,.3v41h0c-.3,2.9,9.2,1.9,10.7,2.6a1.77,1.77,0,0,0,1.7-1.8c-.1-.8.2-40.7-.1-41.4h0c2.1.1,4.1.1,6.2.1.8,1.3-2.5,44.2,1.9,43.1,1.8-.6,10.6,1.6,10.4-2-.2-.8.4-40.5-.2-41.1,2,0,3.9-.1,5.8-.1-.3.7,0,40.7-.1,41.4a1.63,1.63,0,0,0,1.6,1.8c1.5-.7,11.9.4,11.6-2.6h0v-41l5.6-.3h.1v40.4h0c-.3,3.5,9.2.4,10.7.8a1.61,1.61,0,0,0,1.6-1.7h0V132h.1l5.9-.6c-1.1,1.4,0,28.7-.4,30.2.5,1.4-1.3,11.5,1.3,11.4,3.1-1.4,10.4.1,11.1-3.8-.2-1.2.4-38.2-.2-39.3h0c2.3-.4,4.5-.7,6.7-1.1a2.54,2.54,0,0,0-.3,1.5c.2.7-.4,38.1.2,38.6,2.8.1,11.8-1,12.1-4.6-.4-12.7.5-25.7-.3-38.3h0c2.4-.7,4.6-1.4,6.5-2.1-.3,9.9,0,20-.1,30,.7,2-2.1,12.4,3.1,8.5,11.2-3.7,4-34,5.9-44.6a1.38,1.38,0,0,1-.4.3V118h0c-16.6-28.7-142-19.1-172.4-11.2.1,0,.2-.1.3-.1-9.5,2.8-18.2,6.1-15.4,11.6a.1.1,0,0,1-.1-.1v.1c-.3-.2-.5-.5-.8-.7,2.3,13.1-6.1,37.6,6,45,1.3.1,3.1,2,3.2-1.1h0c0-12.6.2-25.2-.1-37.8a56.79,56.79,0,0,0,6.2,2h.1C405,126.1,404.9,126.4,404.9,126.7Z",
    fill: "#f0592b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "584.6 236.4 584.7 236.4 584.6 233.8 584.6 236.4",
    fill: "#d3a653"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,223.7v2.6A11.29,11.29,0,0,0,584.6,223.7Z",
    fill: "#d3a653"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M383.8,225.8h0V223h-.1a6.61,6.61,0,0,0,0,2.8Z",
    fill: "#d3a653"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,227.3V232A18.48,18.48,0,0,0,584.6,227.3Z",
    fill: "#bd4b28"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,383.9v2.5a2.75,2.75,0,0,0,0-2.5Z",
    fill: "#d3a653"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M383.7,208.1V208c25.9,15.5,50.2,18.5,106.2,20.2,14,.3,28.5-1.8,42-2.4h0c.6-.7,2.1-1.2,2.9-.5h0c1.8-.3,3.6-.6,5.3-.9l-.2-.1h0c1.7-.5,4.3-1.7,5.9-1,38-9.6,49.6-13.4,28.4-47.4-1.8-2.7,2.9-5.5,1.2-8.8-2.1-7.7-5.9-1.3-5.9-5.4.1-6.2-.2-31.1.1-37.7a60.18,60.18,0,0,1-6.4,2.1h0c.6,13,.3,26.5.1,39.6-1.2,1.4-13.1,5.5-12.1,2.1.3-11.4-.5-28.1.3-38.9-2.1.4-4.3.8-6.6,1.1h0c.6,1.1,0,38,.2,39.2-.7,3.9-7.9,2.3-11.1,3.8-2.6.1-.8-10.1-1.3-11.4.4-1.6-.7-28.7.4-30.2l-5.9.6h0c-.9,1.1,2,43.7-1.7,42.2-1.5-.4-10.9,2.7-10.7-.8h0V133l-5.6.3c-.8,1.1,2,44.3-1.7,42.8-1.6-.5-11.9,2.8-11.6-.9V134.3c-.2-1.5-4-.1-5.6-.5h-.1c.3.8,0,40.2.1,41.1.2,3.6-8.5,1.5-10.3,2-4.4,1.2-1.1-42-1.9-43.1-2.1,0-4.2,0-6.2-.1h0c-.6,1.9,2.1,43.8-1.6,43.2-1.5-.7-10.9.3-10.7-2.6h0v-41l-6-.3h0c-1.1,1.2,2.4,43.3-1.7,42.1-.5-.1-9.7-.8-9.8-1.2-.7-.2-1-1.6-.9-1.6V131.9l-6.2-.6c1.1,1.1,0,38.5.4,39.9-.4,4-7.9-.5-10.7,0-3.2,0-1.3-6.6-1.8-8.4.4-9.5-.9-23.8.5-33-2.3-.4-4.7-.8-6.8-1.2a2.2,2.2,0,0,1,.2,1.4v28c.8,12.9.4,12.8-11.6,8.2-1.3-10.4-.6-29.8-.3-40.3a41.11,41.11,0,0,1-6.2-2c.3.9,0,36.8.1,37.8,0,2.8-1.8,1.4-3,1.1-6.9,4.7-.7,8.6-1.8,13a51.91,51.91,0,0,0-10.3,32.3Z",
    fill: "#d6842d"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M578.2,118h0c2.4-6.8-8.4-8.8-13.1-10.5C573.9,110.7,579.7,112.7,578.2,118Z",
    fill: "#d6842d"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M390.6,118.3c-2.5-5.6,5.9-8.8,15.5-11.6-5.3,2.1-17.3,3.1-16.3,10.9A3.78,3.78,0,0,0,390.6,118.3Z",
    fill: "#d6842d"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M584.6,383.9h0V207.7c1.3-.2-11.9,8.6-24.7,11.9-1.9.5-3.9,1-5.8,1.6-2.5.7-5.2,1.3-8.1,1.9-1.8.4-3.6.7-5.5,1.1-1.7.3-3.5.6-5.3.9l-3.1.4c-1.3.2-2.6.3-3.9.5-49.4,5.3-119.2.3-144.3-18.2,0,.2.1,14.8.1,15h0c-.4,7.3,2.3,19,.1,26.3h0l.1,16c24.6,1.1,8.1,122.4,12.6,135.8h0c47.2.1,102.9-15.1,149.1,10.3,27.7-9.1,39.9-17.1,39.1-27.3Zm-68.3-24.7c-17.5,9.8-29.1,32.1-52.9,27.6-18.2-3.1-31.6-14.6-30.6-35.1-1.4-17.5,16.6-28.6,20.5-44.7-1.1-17.9.9-37.1,16.8-47.9,16-12,39.6,2.5,38.5,22,2.9,19.9-15.8,30.1-20.1,47.3,10.4-1.6,15.2-12,22.7-18.1,54.1-38,75,42.2,13.4,47.2A29.2,29.2,0,0,0,516.3,359.2Z",
    fill: "#f0592b"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M483.2,301.6a3.32,3.32,0,0,0,1.4-1,4.51,4.51,0,0,1-1.4,1,2.54,2.54,0,0,1-1.7.4A3.29,3.29,0,0,0,483.2,301.6Z",
    fill: "#f0592b"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M496.6,279.5c4.2,14.6-19,31.1-7.6,31.8C516.8,290.7,493.2,245.9,496.6,279.5Z",
    fill: "#d6842d"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M449.9,329.2c-3.1,2.7-10.8,13.5-1.5,11.6,9.4-11.2,20.4-24.7,17.9-40.5-2.3-5.6-7.4-.2-5.6,4C460.5,313.9,456,321.9,449.9,329.2Z",
    fill: "#d6842d"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M461.2,335.4c-2,0-3,2.1-4.2,3.5a34.8,34.8,0,0,1,5.1-3.4A2.77,2.77,0,0,0,461.2,335.4Z",
    fill: "#d6842d"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M444.7,354.3c3.2-6.9-2.4-12.4-5.4-4.3a26.68,26.68,0,0,0,3.7,21.1A24,24,0,0,1,444.7,354.3Z",
    fill: "#d6842d"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M462.7,293.5a2.72,2.72,0,0,0,2.3-3.1h0c-.4-3.8,4.6-14.5-3.6-10.2C459.4,282.2,456.2,294.2,462.7,293.5Z",
    fill: "#d6842d"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M486.8,278.4c-2.5,3.9-.8,9.9-3.9,14-2.2,2.9-7.3,10.8.2,9.1C488.1,299,497.6,275.7,486.8,278.4Z",
    fill: "#d6842d"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M473.5,317.5a3,3,0,0,0-3.5,1.1c-.7,4.1-3.2,7.8-5,11.6,4.1,8.6,11.3-6.3,10.3-11A2.78,2.78,0,0,0,473.5,317.5Z",
    fill: "#d6842d"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M537.6,355.1c50.4-20.3,16-77.8-26.4-44.7-7.4,6-12.2,16.5-22.7,18.1,4.3-17.2,23-27.4,20.1-47.3,1-27.6-36.5-35.4-48.5-11.4-7.7,10.6-6.9,24.5-6.8,37.3-7.3,20.4-28.4,35.2-18.3,59.3,2.6,11.3,12.4,13.5,20,18.6,1.5.4,7,2.3,8.4,1.9,30.7,5,36.6-26.8,61.1-29.2A46.18,46.18,0,0,0,537.6,355.1Zm13.8-26.5h0c1-3.4,6.1-4.5,6.5-.2-1.4,5.1-5.6,9.3-9.3,13.1-2.6,6.7-39.5,16.5-26.5,4.4C534.2,345.5,545.5,339.1,551.4,328.6Zm-12.9-.9.3-.3h0c1.6-2.2,5.6-.7,5.3,2.1-2.1,5.8-19.7,16.3-23,8.5h0C523.5,332.6,534.8,334.1,538.5,327.7Zm-43.2-57c10.8-15,9.6,34.2-6.5,40.6-11.9-1.1,14.3-17.6,6.8-38-.1-.7-.2-1.6-.3-2.6Zm-15.7,26.6h0c6.6-5.2,3.6-16.2,8.5-19.5,9,.1-.9,27.5-7.9,23.7A3,3,0,0,1,479.6,297.3Zm-6.9,20.1a2.83,2.83,0,0,1,2.6,1.9,4.48,4.48,0,0,1,.1,1.2h0c.7,5.1-9,19.2-10.1,8.6a28.33,28.33,0,0,0,4.7-10.5A3,3,0,0,1,472.7,317.4ZM483,354.9c-9.6-.6-14.2,8.3-20.4,12.8-11-5.6,17.5-24.8,23-17a.9.9,0,0,1,.1.5C486.1,353.2,485.1,354.8,483,354.9ZM449.1,366c-6.8-4.4,9.7-27.1,15.5-20.2a2.77,2.77,0,0,1-.8,3.9C455.5,351.5,455.6,365.6,449.1,366Zm7.8-27h0c1.5-1.7,2.7-4.2,5.3-3.5a37.36,37.36,0,0,0-5.3,3.5Zm1.9-49.9c-.9-5.5,5-14.9,7.7-7-.9,2.7-1.9,5.4-1.6,8.3h0a2.55,2.55,0,0,1-.1,1.2C463.4,295.5,457.9,293.1,458.8,289.1Zm-14.3,47.2h0c7.4-10.2,17.1-19.8,15.9-33.6-.4-2.2,0-4.6,2.7-4.9C479,300.4,442.4,358.1,444.5,336.3Zm-.7,10.1c5.9,4.4-5.3,17-.5,25a26.49,26.49,0,0,1-3.8-21.2C439.9,348.1,441.5,345.4,443.8,346.4Zm9.7,29.5c0-.1-.1-.5.1-.5.3-1,.7-2.2,1-3.2h0c1.9-5.3,7.9-1.2,5.3,3h0c-.4.6-.4,1.7-.8,2.4,0,.1-.1.2-.1.3a1.33,1.33,0,0,1-.3.5C457,380.7,453,378.6,453.5,375.9Zm51.2-27c-3.3,2.4-13.4,8.4-14.4,1.6.6-4.5,8-3,10.7-6.2C503.9,341.6,508.2,346.6,504.7,348.9Zm6.9-20.5c-2.7,8.4-39.9,22.5-42.4,13.5h0c.9-4.6,7.7-3.6,11.4-4.4,9.4-1.2,18-3.8,24.7-10.9C507.1,321.5,515.2,323,511.6,328.4Zm2.4-7.8a3,3,0,0,1-1.2-3.8h0c.7-2.2,6.7-6.8,9.2-6.7,3.1-.5,4.6,4.3,1.5,5.4-3.9.6-5.6,7.1-9.5,5.1Z",
    fill: "#fdb73e"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M449,365.9c2,.7,3.1-.3,4.3-3.2,1.5-7.1,7.8-10.2,11.8-15.2C461.8,335.8,441.6,361.6,449,365.9Z",
    fill: "#d6842d"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M556.7,326c-8.2-.9-10.3,20-34.5,19.8a2.6,2.6,0,0,0-2.7,3.2c5.8,7.7,23.4-2.4,29.5-7.9C551.9,337.3,560.7,330.9,556.7,326Z",
    fill: "#d6842d"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M462.5,367.7c.8.2,1.9-.4,2.7-1.7,4.8-12.3,22-8.3,20.2-15.2C480,343,451.3,362.1,462.5,367.7Z",
    fill: "#d6842d"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M511.4,324c-2.6-2.1-4.6.7-6.1,2.7-6.7,7.1-15.3,9.8-24.7,10.9-3.5.8-10.6-.2-11.4,4.4h0C471.2,351.4,519,334.5,511.4,324Z",
    fill: "#d6842d"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M529.3,333.6c-2.7,1.4-7.9.2-8.1,4.1h0c3.2,7.7,20.8-2.7,22.9-8.5.3-2.9-3.7-4.2-5.3-2h0A22,22,0,0,1,529.3,333.6Z",
    fill: "#d6842d"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M455.1,378.8a2.66,2.66,0,0,0,3.5-.6,11.47,11.47,0,0,0,1.1-3.1h.1c2.8-4.2-3.6-8.2-5.3-3h0C453.8,374.3,452.3,377.5,455.1,378.8Z",
    fill: "#d6842d"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M505.6,345.3a1.38,1.38,0,0,1-.3-.4c-3.3-3.8-7.1,2.6-10.9,2.5-2.2.3-4.6,1.1-4.1,3.8C492.1,357.1,507.3,350.5,505.6,345.3Z",
    fill: "#d6842d"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M514,320.6h0c3.9,2,5.7-4.4,9.5-5,3-1.2,1.6-5.8-1.5-5.4-2.5-.1-8.5,4.5-9.2,6.7A2.94,2.94,0,0,0,514,320.6Z",
    fill: "#d6842d"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M274.2,413.2c2.4,0,3.9-.1,7-.2-21.7-2.9-33.2-4.2-53-5.8-.2,9.5-1.4,23.1,9.1,27.9,17.1,3.2,18-20.7,36.9-21.9l.2.1A.31.31,0,0,0,274.2,413.2Z",
    fill: "#ef6ba0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M380.1,433a51.44,51.44,0,0,0,4.9,3.2l.2-.1A43.26,43.26,0,0,1,380.1,433Z",
    fill: "#ef6ba0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M373.9,427.6c-5.4-9.4,10.4-15.7,17-19.2,4.6-1.8,6.4-1.6,5.6-7.2h0c-4.6-14,12.1-134.3-12.5-135.9h-.1c-.1,0-.1,0-.2-.1h0a26.48,26.48,0,0,0-6.9-.6V251.8H243.9v12.9c-16.2,1.1-16.7,19.3-15.8,31.6h0V386c5.9-2,12.7-1.6,18.8-1.1.4-3.5-1-68.9,1-70.2a22.47,22.47,0,0,1,20.3-15.4h0c20,4,76.8,2.4,87.4,0h0c35.2-1.6,17.2,71.7,21.3,90.7-2.9,22.8-16.7,21-40.2,23.1a34.2,34.2,0,0,1-6,25.5c15.1,4.8,30.8.4,46.2-1.4A11.91,11.91,0,0,1,373.9,427.6Z",
    fill: "#ef6ba0"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M246.9,388.1c-6.3-1.1-13.2-.7-18.9,2.4v11.9c28.7,3.1,21.1,5.5,18.8-14.3Z",
    fill: "#ef6ba0"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M301.1,228.1H247.5c-7-.2-14.9-1.2-13.2,8.7h0c.5,4.3-2.1,15.2,4.9,15H379.5a5,5,0,0,0,5-4.9c-.4-2.1.8-14.9-.8-16.4-1.8-4.1-15.2-1.7-18-2.3H321.6l-20.5-.1Z",
    fill: "#fdb73e"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M248.6,385.1c5.8.5,13.4,2.5,20.5,4.5-3.7-17.8,8.5-36.5,12.1-54,5.4-16.7,26.2-22.7,40.5-13,1-2.7-1-9.5,2.2-10,5.9,1.2,9.7,5.2,10.5,11.5,1.4,3.8,8.3,1.2,11.7,2.4,3,2.8-2.6,10.9,1.8,12.9,5.3.7,13,8.8,8.9,13-3-.1-6-.3-9-.4,3.5,7.3,4.3,14.7,1.3,22.3-8,21.2-34.2,17.5-52.4,22.1h0c5.3,1.9,10.3,4.5,9.8,9.7,3.6-2.2,6.6-4.3,6.6-4.3,8.6-3.9,21.5,2.6,23.7,11.3,23.5-2.1,37.3-.4,40.2-23.1-4.5-18.9,14.5-91.8-21.3-90.3h0s-25.1,2.8-44.3,2.8a388.18,388.18,0,0,1-43.1-2.8A22.46,22.46,0,0,0,248,315.2c-1.9,1.1-.6,67-1,70.2Z",
    fill: "#fff"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M251.4,403.4c13.2-4,7-14.3-4.4-15.3C246.7,393.6,247.9,399.1,251.4,403.4Z",
    fill: "#fff"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M262.7,411c5.5.7,14.1,2.4,24.2,1.6-11.8-3.9-16.9-3.9-29.4-3.6A16.49,16.49,0,0,0,262.7,411Z",
    fill: "#fff"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M279.1,402.6l1.6-4.1a15.07,15.07,0,0,1-9-4.8h0c-6.1-2.5-7.9,3.7-10.6,7.6-1.2,1.8.8,3.9,2.6,3.7C266.2,404.3,278.3,405.8,279.1,402.6Z",
    fill: "#fff"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M281.2,335.6c-4.7,14.4-8.9,29-13,43.6-3.8,10.1,5.9,12.5,13.1,13.7,18.2,5.4,60.2,3.1,67.6-18.4,3-7.6,2.3-15.1-1.3-22.3-8.9-2.7-5,8.5-6.3,13.9-4,4.5-12.4-5.1-11.9-10.3h0c0-4.2.5-8.7.5-12.9-6.4-4.8-21.6,2.5-24.2-12.5-1.4-7.6,14.9,2,15.8-4h0c0-1.2.1-2.3.1-3.6C307.4,313.1,286.7,319,281.2,335.6Zm39,28.4c1.8-2.9,8.7-6.3,8.4-.5h0c.2,2.1-2.2,3.1-3.4,4.4C322.3,371.7,316.4,367.5,320.2,364Zm-1.3,19.1c2.1-2.3,6.8-6.4,8.6-1.7,1.1,6-12.7,10.6-8.6,1.7Zm-29.2-3c-.4,2.7-4.2,6.1-7,5.6-7.8-3,7-14.3,7-5.6Zm.6-17.1c-2.2,3.4-9,6.6-8.8.2C283,358.2,293,355.1,290.3,363ZM308,383.2a32.34,32.34,0,0,1-4.5,3.8,2.75,2.75,0,0,1-2.5,0c-7.9-5,11.4-14.4,7-3.8Zm.9-18.7h0c-2.7,4.5-11.2,5.3-7.7-1.5h0c2.7-4.5,11.4-5.4,7.7,1.5Zm-2.8-23.8c11.5-3.1-1.2,15.6-4.7,6.1h0C301.1,343.9,304.5,342.5,306.1,340.7ZM289,339.1c6.9.9.6,9.2-3.6,9C279.3,346.6,285.4,339.6,289,339.1Z",
    fill: "#ef6ba0"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M280.7,398.4h0c2.2-4.7-6.7-3.9-9-4.8h0A15.36,15.36,0,0,0,280.7,398.4Z",
    fill: "#ef6ba0"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M322.3,314.4c-.1,4-.7,7.9-.8,11.9h0c-.4,5.9-17.7-3.5-15.8,4,2.6,15,17.8,7.7,24.2,12.5,0,4.2-.5,8.7-.5,12.9h0c-.6,5.1,8.1,15,11.9,10.1,1.3-5.2-2.7-16.5,6.3-13.7,3,.1,6,.3,9,.4,4.1-4.1-3.6-12.4-8.9-13-4.4-2,1.2-10.1-1.8-12.9-3.4-1.2-10.3,1.5-11.7-2.4C334.5,319.1,325.5,308.9,322.3,314.4Z",
    fill: "#93b847"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M288.8,382.4c5.6-11.2-15.5-1.5-6.2,3.4C285.2,386.5,286.9,383.6,288.8,382.4Z",
    fill: "#6e5f91"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2,386.5c3-1.5,7.5-7.4,1.8-8.4h0c-3.5-.1-9.8,6.2-4.9,8.8a3.1,3.1,0,0,0,2.5,0A1.27,1.27,0,0,0,304.2,386.5Z",
    fill: "#6e5f91"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M309.6,361c-1.9-4.4-6.2-.2-8.3,1.9-3.5,6.8,5,6,7.7,1.5h0A3,3,0,0,0,309.6,361Z",
    fill: "#6e5f91"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M308.1,340.4c-2.7.1-6.7,3.6-6.6,6.4h0C303.7,355,316.7,341.3,308.1,340.4Z",
    fill: "#6e5f91"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M320,368.4c2.8,3,8.3-2,8.7-4.9h0C329.1,355.8,316,364,320,368.4Z",
    fill: "#6e5f91"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M283.6,347.4c2.8,2.3,5.4-1.3,7.4-2.9C295.9,334.8,278.3,341.1,283.6,347.4Z",
    fill: "#6e5f91"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M318.8,387.1c3.7,4.8,13.6-7,6-7.9C321.9,379.3,316.2,384,318.8,387.1Z",
    fill: "#6e5f91"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M290.7,359.6c-2.4-4.2-7.7.8-9,3.6C281.1,371,293.2,364.4,290.7,359.6Z",
    fill: "#6e5f91"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M465.4,540.8h0c-20.5-1.3-85.4.4-84.2-28.7-4.6,2.6-10.7,10.7-6.3,15.6a13.57,13.57,0,0,1,4.8,3.4c43.5,25.2,119.2,22.8,165.1,3.5,12.1-8.6,18.5-12.6,3.3-22.6,1.4,9.4-5,15.4-13.7,18.6-22,8.4-45.7,9.9-69,10.2Z",
    fill: "#c3c3c3"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M396.5,406.1h0c-7.5,2.6-14.7,6.2-20.5,11.7-2.9,2.4-4.8,6.5-2,9.7h0v-.1c37,31.3,144.4,31.4,181.7.1h0v.4c0-39.5-125.1-34.2-153.1-23.7C400.6,404.7,398.5,405.4,396.5,406.1Zm137.3,17c0,10.5-32.1,19-71.6,19h0c-93.4.6-92.1-38.8.6-38C486.6,405.4,525.5,405.1,533.8,423.1Z",
    fill: "#c3c3c3"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M555.7,427.9h0v-.4c-6.5,7.2-15.2,11.4-24.3,14.1-47.3,11.7-101.1,13.7-146.5-5.5a44,44,0,0,1-11-8.7h0c-1.1,6,3.3,11.8,7.9,14.6,49.3,22,111.3,20.9,161.6,2.1,1.4-.7,2.8-1.4,4.2-2.2v.1h0C552.5,438.5,555.9,434.2,555.7,427.9Z",
    fill: "#7dd2f6"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5,444.2c-50.3,18.7-112.3,19.9-161.6-2.1-.5,23.3-.2,46.6-.5,69.9-1.4,29.1,63.5,27.6,84.1,28.8,21-1.4,77.6.2,82.8-25.2-.5-23.7-.1-49.9-.6-73.5Zm-31.7,52.6c-.9,1.8-6.1,3.4-5.8,4.4-1.2,1.4,7.1,4.2,4.8,7-5.3,11.7-21.5,8.9-27.9,19h0c-2.7,2.7-11.1,5-13.8,2.5.1-3.1,3.9-8.9-1.8-8.8-9.7.1-17.8-5.5-24.9-11-8.1-9-9.7,13.3-33.9,9.7-3.9-5.2,4.1-14.5,9.1-18.4-3.2-6.1-11.1-11.9-8.1-19.9,7.2-6.1,22.9,4.5,26.2,11.5,1.1,1.8,2.9,1.6,4.2,0,12.9-15.2,18.6-.2,16.7-22.3.1-1.3,1.1-1.9,2.6-2.1,10.8-1.8,21.7.2,26.6,9.9C494.6,483.1,510,484.3,511.8,496.8Z",
    fill: "#015e85"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M545,534.5c-46.5,19.2-121,21.8-165.1-3.4a16.14,16.14,0,0,0-4.8-3.4l-1.1-.3c5.9,38.9,175.7,39.1,181.8,0C551.4,528.5,548.9,532.4,545,534.5Z",
    fill: "#015e85"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M533.8,423.1c-8.5-18.2-47.4-17.6-71.6-18.9-92.8-.6-92.6,38.6,0,38C501.7,442.1,533.8,433.6,533.8,423.1Z",
    fill: "#ebebeb"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M482.7,527.4a9.7,9.7,0,0,1-3.8,2.3A9.7,9.7,0,0,0,482.7,527.4Z",
    fill: "#0a0c0d"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M503.8,486.1c-5.2-4.3-13.1-3.8-18-7.7-4.2-9.3-20.9-14.3-29.1-7.7,2.1,21.8-4.4,7.3-17,22.5-1.4,1.6-3,1.3-4-.5-3.3-6.8-19.3-17.6-26.2-11.2-3,8,5.4,13.7,8.1,19.8-5.1,3.6-13.2,13.4-9,18.3,24.3,3.6,25.5-19,34-9.5,6.6,5.3,15.1,10.9,24.6,10.8,5.7-.1,1.9,5.6,1.8,8.7,2.5,2.7,11.1.2,13.8-2.4h0c4.5-10.1,31.1-8.8,26.7-22.2-7.8-4.6-1.1-4.2,2.2-8.1C511.5,492.4,507.5,488.5,503.8,486.1ZM466.9,510c-4.7.8-7-6.8-7.3-10.6h0c-.4-4.3,7.1-15.1,10.6-9.3C456.1,503,470.6,504,466.9,510Z",
    fill: "#7dd2f6"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M467.4,507.4c-6.1-6.8-3.4-11.6,2.6-17.4-.3-2-3-2.1-4.2-.9a12.78,12.78,0,0,0-6.4,10.3h0C458.3,503.3,467.2,516.1,467.4,507.4Z",
    fill: "#015e85"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M180.1,530.2v-1.5c-14.9,15.1-35.7,18.9-56.2,18.7C139.9,552.8,179,551,180.1,530.2Z",
    fill: "#c3c3c3"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M171.8,463.3h0c-6.5-13,25.7-20.8,34.9-23.2-8.7-49.3-48.3-80-92.1-70h.1c-.1,0-17.4,1.8-17.5,1.8C182.6,384,181,547.8,91.8,551.3v.2c10-1.1,36-5.3,45.7-4.5,16.2-.5,30.6-7.5,42.4-18.2.1-17.3,0-34.9.5-52.1h0C175.9,473.1,171.1,469.5,171.8,463.3Z",
    fill: "#f0592b"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M161.8,462.8c0-1.5,0-3-.1-4.6h0c-1.6-44.2-29.3-80.1-64.4-86.5a61.65,61.65,0,0,0-31,2.2c-14.8-2.9-37.6-7.5-37-24.4-12.6,7.4-5.9,17.4,4.4,22.5,7.4,5.8,28.3,4.8,12.7,12.6C-15.3,425.8,14.2,558.3,92,551.1,131.2,548.7,161.6,510,161.8,462.8ZM89.7,543.2c-23.6,1.1-44.8-14.9-56.1-35.5,13.4,10.6,38.5-4.8,51.4-9.4,32.5-11.4,2.4-69.3-24.3-45.7-9.1,11-32.4,26.5-32.9,42.2C-13,379,139.9,323.5,152.1,458.3h0C153,502.5,129.3,540.2,89.7,543.2ZM70.1,454.5c22.3-6.8,31.5,36.3,8.1,40.2C57.7,498.2,49.8,460.2,70.1,454.5ZM59.8,495.9c3.6,6.4-9.7,7.8-12.9,9.7-3.1,1.1-10.8-4.5-11-7.7-.9-11.8.6-11.8,9.4-18.8C51.7,473.6,57,493.3,59.8,495.9Z",
    fill: "#c3c3c3"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7,543.2c39.7-3,63-40.7,62.3-84.8h0C139.7,323.5-13,379.3,27.7,494.9c.4-15.6,23.9-31.3,32.9-42.3,26.7-23.5,56.9,34.3,24.4,45.7-13,4.6-37.9,20-51.4,9.4C44.8,528.3,66.2,544.3,89.7,543.2Z",
    fill: "#ebebeb"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8,496c-2.7-2.6-7.9-21-13.9-17.2-8.9,6.9-11,7.2-10,19.1.3,3.4,7.7,8.5,11,7.7C50,503.7,63.4,502.3,59.8,496Z",
    fill: "#ebebeb"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2,477.1c3.7,27,38.5,20,33.6-5.2-4.3-27.1-37.9-20.8-33.6,5.2Z",
    fill: "#ebebeb"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M346.3,561.3C320.7,572.6,179.9,582,180,543.4,137.4,574,279.6,582,295,577.6c14.3.7,103.8-13,66.3-34.2C362.9,553.4,355,558.3,346.3,561.3Z",
    fill: "#c3c3c3"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2,462.6c-39.9,30-157.3,30.2-197.3,0-.5,39.1,194.5,38.7,197.3,1h0l-.1.1A1.45,1.45,0,0,0,369.2,462.6Z",
    fill: "#99d47e"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M180.2,520l-.1,8.7h0c0,2.9-.1,5.7-.1,8.6h0c-12.1,46.2,141.1,35.2,166.2,23.9,8.8-2.9,16.5-7.9,14.8-17.8-.3-22.2,0-44.6-.5-66.8-1.7.8-3.5,1.6-5.3,2.4-55.3,17.2-120.4,18.9-174.6-2.5h0C180.3,491,180,505.5,180.2,520Zm43.7,7.3c0-13.8,22.5-25,50.2-25s50.2,11.2,50.2,25h0c0,13.8-22.5,25-50.2,25s-50.2-11.2-50.2-25Z",
    fill: "#93b847"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M357.7,565.1c-54.3,18.7-134.9,21.6-185.8-6.9,6.4,37.2,190.8,37.5,197.4.1C364.7,559.3,361.9,563.2,357.7,565.1Z",
    fill: "#99d47e"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 259.7,
    y1: 478.7,
    x2: 254.6,
    y2: 478.5,
    fill: "none"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M184.3,455.9c-5.8,13.1,32.3,20.2,64.9,22.3,0,0-3.2-26.2-1-39.4C226.1,441.6,199.6,440.9,184.3,455.9Z",
    fill: "#ebebeb"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M265,478.8c-1.8,0-3.5-.1-5.1-.1C261.5,478.7,263.3,478.8,265,478.8Z",
    fill: "#ebebeb"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M330.2,443.7a14.19,14.19,0,0,0-2.2-.5l-78.6,35c31,.7,89.7,2.4,107.9-17.7,1.7-3.9-1.9-6.8-4.8-8.7C345.7,447.6,337.8,445.8,330.2,443.7Z",
    fill: "#d6842d"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M333.4,434.5a20,20,0,0,0,2.1-4.5c.9-3.8,2.3-11.3,1.2-16.5h0c-1.2-6.4-10.1-11.8-16.3-12.4-17.7-2,4.1,28.9-46.2,12.2-19,.7-20,25.2-37.1,21.8-7.9.9-15.8,2.1-23.6,3.6-4.8-25.8-16.6-46.6-35.2-60.7,10.2-3.3,22.6-8.2,27.6-17.2v-3.5c-3.7-1.9-4.2-7.3-8.8-8.2h0c2,16.4-15.8,19.5-27.7,23a61,61,0,0,0-54.9-2.1c4.9-.2,11.7-1.6,16.5-1.7,36.6-1.3,68.2,29.7,75.6,71.7-8.6,1.9-17.2,4.5-24.9,8.7-4.7,3-15.1,8-10.1,14.6a2.2,2.2,0,0,1,.1-.8c39.8,30.1,157.3,30,197.3,0,0,.4.1.7.1,1.1,6.3-11.9-18.5-19-27.6-22.1C336.8,439.5,326.5,440.9,333.4,434.5Zm-1.6,9.5c7.2,1.9,14.5,3.8,20.9,7.7,2.9,1.9,6.5,4.9,4.8,8.7-18.3,20.3-77.1,18.5-108.2,17.8.9-.1,78.5-35.7,79.4-35A28.06,28.06,0,0,1,331.8,444Zm-134,3.3c13.8-4.9,33.6-7.5,50.4-8.6-2.2,13.1,1,39.4,1,39.4h0C210.7,476.6,158.2,463.3,197.8,447.3Z",
    fill: "#c3c3c3"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M313,402.1s-3,2.1-6.6,4.3c-.3,2.9-2.5,6.6-5,7.5-4.2,1.4-8.9,0-14.4-1.3-2.1.2-4.1.3-5.9.4-3.1.1-4.6.2-7,.2,10.6,4.4,39.8,11.3,38.9-11.1Z",
    fill: "#015e85"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M287.1,412.5c5.5,1.4,10.1,2.7,14.3,1.3,8.6-5,5.1-15.2-4.8-17.2-9.8-2.9-17.5-4-27.4-7-17.4-5.5-48.6-10.9-55.5,9.5,16.7,18.6,51.4,3.5,73.4,13.4Zm-47.3-8.4c-30.3.1-12.9-21,7.1-15.9,11.4,1,17.7,11.3,4.4,15.3h0A40.44,40.44,0,0,1,239.8,404.1Zm41.1-6.1c-1.1,1.8-1.5,6.3-4.3,6.2l-12.8.6c-2.2.1-3.7-2-2.6-3.7,1.6-1.7,4.1-8.9,7.3-8.1C271.4,394.2,282.2,392.9,280.9,398Z",
    fill: "#c3c3c3"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M274.1,552.3c27.7,0,50.1-11.2,50.2-25h0c0-13.8-22.5-25-50.2-25s-50.2,11.2-50.2,25h0C224,541.1,246.4,552.3,274.1,552.3Z",
    fill: "#f0592b"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPantryItems, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pantry_items.59ab8c61.svg";
export { ForwardRef as ReactComponent };